module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/工作站-应用场景1.fb364e7b.png";